/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { ValidatorMap } from "ember-changeset/types";
import type { IntlService } from "ember-intl";
import JournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import InfectionDeclaredJournalEvent from "parog-web/models/infection-declared-journal-event";

export default class RhumatowiseInfectionEditionFormComponent extends JournalEventBasedComponent {
  @service declare intl: IntlService;

  static forcDisplayName = "Déclarer une infection";
  static fullComponentId = "infection/edition-form";

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  static journalEventClass = InfectionDeclaredJournalEvent;

  journalEventProperties = [
    "occurredAt",
    "infectionType",
    "requiringAntibiotics",
    "leadingToTreatmentModification",
    "leadingToHospitalization",
    "comments"
  ];

  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;
}
